import React from "react";
import {
  BankOutlined,
  BarChartOutlined,
  CalendarOutlined,
  DollarOutlined,
  EditOutlined,
  HeartOutlined,
  IdcardOutlined,
  LikeOutlined,
  ReadOutlined,
  SmileOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { icons as searchIcons } from "../../../pages/search/config";

/**
 * Category card icons (Explorer Figma, "2a. Data Catalog Anatomy": "All icons used are from the
 * Ant library"). Categories without a Figma icon fall back to the search config's icon.
 */
const FIGMA_ICONS = {
  age: <UserOutlined />,
  gender: <IdcardOutlined />,
  partisanship: <LikeOutlined />,
  marital_status: <HeartOutlined />,
  ethnicity: <TeamOutlined />,
  urbanicity: <BankOutlined />,
  presence_of_children: <SmileOutlined />,
  turnout_scores: <BarChartOutlined />,
  vote_history: <EditOutlined />,
  scores: <StarOutlined />,
  education: <ReadOutlined />,
  income: <DollarOutlined />,
  early_vote: <CalendarOutlined />,
};

export const categoryIcon = (category) => FIGMA_ICONS[category] ?? searchIcons[category] ?? null;

/** Category card order (Explorer Figma, "2a. Data Catalog Anatomy"). Unknown categories go last. */
const CATEGORY_ORDER = [
  "age",
  "gender",
  "partisanship",
  "marital_status",
  "ethnicity",
  "urbanicity",
  "presence_of_children",
  "turnout_scores",
  "vote_history",
  "scores",
  "education",
  "income",
  "early_vote",
];

export const orderedCategories = (categorized) => {
  const rank = (category) => {
    const i = CATEGORY_ORDER.indexOf(category);
    return i === -1 ? CATEGORY_ORDER.length : i;
  };
  return Object.entries(categorized).sort(([a], [b]) => rank(a) - rank(b));
};

/** 4 cards per row from 1200px, 3 below (Figma 5e), 2 on phones where 3 do not fit. */
export const CARD_COLUMNS = { xs: 12, sm: 8, xl: 6 };

const LOWERCASE_WORDS = new Set(["of", "and", "in", "the"]);

/** Category label in title case with short words lowercased ("Presence of Children"). */
export const categoryLabel = (category) =>
  String(category ?? "")
    .split("_")
    .map((word, i) =>
      i > 0 && LOWERCASE_WORDS.has(word) ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
